var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m13.88 15.92-.126.572q-.57.247-.909.378a2.2 2.2 0 0 1-.787.13q-.69 0-1.072-.371a1.26 1.26 0 0 1-.382-.943q0-.223.028-.454.03-.233.093-.524l.474-1.854a10 10 0 0 0 .107-.505q.043-.238.043-.435 0-.355-.133-.495-.132-.14-.507-.14-.185 0-.377.063-.195.064-.332.121l.127-.571q.465-.21.891-.36.427-.149.807-.149.684 0 1.055.366t.371.949q0 .121-.025.425-.027.306-.095.56l-.473 1.846a5.4 5.4 0 0 0-.15.94q0 .369.15.502.15.135.516.134.172 0 .39-.067a2 2 0 0 0 .316-.117M14 8.169q0 .483-.33.822-.33.34-.796.34a1.08 1.08 0 0 1-.8-.34 1.13 1.13 0 0 1-.333-.822q0-.482.334-.825.332-.343.8-.343.465 0 .795.343t.33.825"
  })));
};
export default SvgInfo;